export function requestHeaders() {
    const headers = {
        'Content-Type': 'application/json',
        Origin: window.location.origin,
    };
    return headers;
}
